export const PAGES_MENUS = [{
  id: 1,
  title: "Танилцуулга",
  child: [{
    id: 1,
    title: "Бидний тухай",
    href: "/about-us"
  }, {
    id: 2,
    title: "Ажлын байр",
    href: "/career"
  }, {
    id: 3,
    title: "Холбоо барих",
    href: "/contact-us"
  },]
}];